module.exports = __webpack_public_path__ + "img/target-center-phone.57d28578.svg";